<div class="row mx-0 question-completion position-relative">
  <div class="pointer-cursor position-absolute right-align z-999">
    <img src="assets/images/close-movie.svg" alt="" (click)="close()" height="24" width="24">
  </div>
  <div class="col-12 px-0 px-lg-4">
    <p class="mulish-bold text-28 text-center font-green">{{'You’ve succesfully completed this topic' | translate}}</p>

  </div>
  <div class="col-12 px-0 text-center">
    <img class="badge-img" *ngIf="data?.badge == 'None'" src="assets/images/no-badge.svg" alt="">
    <p *ngIf="data?.badge == 'None'" class="mulish-normal text-xxs mt-3">{{'No badge' | translate}}</p>
    <img class="badge-img" *ngIf="data?.badge == 'Bronze'" src="assets/images/bronze-badge.svg" alt="">
    <p *ngIf="data?.badge == 'Bronze'" class="mulish-normal text-xxs mt-3">{{'Bronze badge' | translate}}</p>
    <img class="badge-img" *ngIf="data?.badge == 'Silver'" src="assets/images/silver-badge.svg" alt="">
    <p *ngIf="data?.badge == 'Silver'" class="mulish-normal text-xxs mt-3">{{'Silver badge' | translate}}</p>
    <img class="badge-img" *ngIf="data?.badge == 'Gold'" src="assets/images/gold-badge.svg" alt="">
    <p *ngIf="data?.badge == 'Gold'" class="mulish-normal text-xxs mt-3">{{'Gold badge' | translate}}</p>
    <div class="mulish-bold score">
      <div class=" text-xxs d-flex justify-content-center align-items-center">
        {{'Your total score:' | translate}} {{data?.score}} / {{data?.maximum_score}}
      </div>
    </div>
    <div class="mt-5">
      <p class="mulish-800 text-16">{{'You proved yourself you’re a genie for this topic! Keep up the good work!' | translate}}</p>
    </div>
    <div *ngIf="questionStatus?.answered_questions < questionStatus?.total_questions"
      class="bg-danger d-flex text-white badge-custom align-items-center cursor-pointer mulish-bold text-13 margin-top-24"
      (click)="playNextTopic()">
      <span> {{'play next topic' | translate | uppercase}} </span>
      <mat-icon class="ml-3">arrow_right_alt</mat-icon>
    </div>

    <div
      class="py-2 px-3 flex-center text-13  cursor-pointer mulish-bold  btn-block mb-3 margin-top-24 text-center color-5F5F5F"
      (click)="goToHome()">
      <div> {{'Cancel' | translate | uppercase}} </div>

    </div>

  </div>

</div>
